import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'
import {connect} from 'react-redux';
import Arrow from '/app/src/component/Arrow';
import SystemModel from '/app/src/model/System/model'
import SVG from 'react-inlinesvg';

class MenuSubTitle extends React.Component {
    constructor(props){
        super(props)
        this._onClick = this._onClick.bind(this)
        this.state = {
            hover: false
        }
    }
    _onClick(){
        if(this.props.onClick){
            this.props.onClick()
            return;
        }
        if(this.props.to){
            this.props.dispatch(SystemModel.navigateTo(this.props.to))
            return;
        }

        this.props.dispatch(SystemModel.menuToogle(true))
    }

    render(){
        let text = this.props.text
        let icon = this.props.imgSrc ?
            <img alt='' className={style.ItemIcon} src={this.props.imgSrc}/>
            : <SVG cacheGetRequests={true} style={{fill: this.props.svgfill}} className={style.ItemIcon} src={this.props.svgSrc} />
        return (
            <div className={style.MenuSubTitle} onClick={this._onClick} style={{borderBottom: 'solid 6px'+this.props.svgfill}}
            onMouseOver={(e)=>this.setState({hover: true})}
            onMouseOut={(e)=>this.setState({hover: false})}

            >
                <Flex height='100%' hAlignContent='left'>
                    <Flex center height='50px' width='50px' ml='10px' mt='5px'>
                        {!this.props.noArrow &&
                        <Arrow direction='left'
                            borderRadius='1000px'
                            backgroundColor={this.state.hover&&'rgb(78,78,78)'}
                            color='grey'
                            onClick={this._onClick}
                        />
                        }
                    </Flex>
                    <Flex vAlignContent='center' grow hAlignContent='left' paddingLeft='30px'>
                        {icon}
                        <div className={style.subTitleText}> {text} </div>
                    </Flex>
                </Flex>
            </div>
        )
    }
}

export default connect()(MenuSubTitle)



// WEBPACK FOOTER //
// ./src/component/Menu/SubTitle.js